import { TimeReportStage } from "./types";

export const TIME_REPORT_EDITABLE_STAGES: TimeReportStage[] = ["DRAFT", "REJECTED"];
